import React from 'react';

import { Grid } from 'components';

const Container = props => {
  return (
    <Grid
      item
      xs={12}
      sm={6}
      md={4}
      lg={4}
      style={{ margin: '0 auto' }}
      {...props}
    />
  );
};

export default Container;



// WEBPACK FOOTER //
// ./src/common/components/Item.js